import { Form, Input, Button, Checkbox, Row, Col } from "antd";
import { Link } from "react-router-dom";
import rules from "@/config/rules";
import { ReactComponent as PasswordHide } from "@/assets/icons/hidepassword.svg";
import { ReactComponent as PasswordShow } from "@/assets/icons/showpassword.svg";
import "../index";

const SignUpRender = ({
  submitLoading,
  handleRequestSignUp,
  sendCode,
  isShowCode,
  time,
}) => {
  const [signForm] = Form.useForm();
  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;

  return (
    <div className="signupPage text-center">
      <div className="topContent">
        <h1 className="text-white mb-0">欢迎注册</h1>
      </div>
      <div className="sectionSignup">
        <div className="container">
          <div className="signForm bg-white mx-auto rounded-3">
            <Form
              name="form"
              form={signForm}
              onFinish={handleRequestSignUp}
              validateTrigger="onBlur"
              autoComplete="off"
            >
              <Form.Item
                name="username"
                className="require_item"
                rules={[
                  { required: true, message: "请输入您的手机号!" },
                  {
                    pattern: new RegExp(rules.phone),
                    message: "手机号格式不正确，请重新输入",
                  },
                ]}
              >
                <Input placeholder="手机号" />
              </Form.Item>
              <Row>
                <Col>
                  <Form.Item
                    name="code"
                    className="require_item"
                    rules={[{ required: true, message: "请输入您的验证码!" }]}
                  >
                    <Input placeholder="验证码" className="codeInput" />
                  </Form.Item>
                </Col>
                <Col className="h-100">
                  <Button
                    type="primary"
                    ghost
                    className="code rounded-1"
                    onClick={() => sendCode(signForm.getFieldValue("username"))}
                    disabled={isShowCode ? true : false}
                  >
                    {isShowCode ? `${time}秒后重试` : "获取验证码"}
                  </Button>
                </Col>
              </Row>
              <Form.Item
                name="password"
                className="require_item password-input"
                rules={[
                  { required: true, message: "请输入您的密码!" },
                  {
                    pattern: new RegExp(rules.password),
                    message:
                      "密码格式错误，8~20位字符，必须包含数字与字母，不允许出现中文与空格。",
                  },
                ]}
              >
                <Input.Password
                  placeholder="密码"
                  iconRender={passWordIconRender}
                />
              </Form.Item>
              <Form.Item
                name="password_confirmation"
                className="require_item"
                rules={[{ required: true, message: "密码不一致,请重新输入" }]}
              >
                <Input.Password
                  placeholder="确认密码"
                  iconRender={passWordIconRender}
                />
              </Form.Item>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                className="text-start agreement-text pb-lg-3 pb-0"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(new Error("请同意用户服务协议!")),
                  },
                ]}
              >
                <Checkbox>
                  已阅读并同意牛学长
                  <a
                    href="https://www.niuxuezhang.cn/terms-and-conditions.html"
                    className="text-underline"
                    target="_blank"
                  >
                    《用户服务协议》
                  </a>
                  和
                  <a
                    href="https://www.niuxuezhang.cn/privacy.html"
                    className="text-underline"
                    target="_blank"
                  >
                    《隐私政策》
                  </a>
                </Checkbox>
              </Form.Item>
              <Form.Item className="text-center mb-0">
                <Button
                  className="ant-btn ant-btn-primary ant-btn-lg submitButton fs-5 fw-bold"
                  htmlType="submit"
                  loading={submitLoading}
                >
                  立即注册
                </Button>
              </Form.Item>
              <p className="mb-0">
                已有账号{" "}
                <Link to="/login" className="text-underline">
                  登录
                </Link>
              </p>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpRender;
